{
    "footnote-label": "Footnotes",
    "footnote-back-label": "Back to reference {{index}}",
    "footnote-back-label-many": "Back to reference {{from}}-{{to}}",
    "store-different-origin": "The Hyperbook file is from a different origin {{origin}}. Do you want to import it anyways?",
    "store-import-successful": "The Hyperbook file has been imported successfully.",
    "store-not-supported-file-version": "The Hyperbook file has an unsupported version {{version}}.",
    "store-reset-successful": "The Hyberbook has been reset successfully.",
    "store-reset-confirm": "Are you sure you want to reset the Hyperbook? This will remove all your data.",
    "shell-search": "Search",
    "shell-toggle-dark-mode": "Toggle between Dark and Light Mode",
    "shell-reset-hyperbook": "Reset Hyperbook",
    "shell-import-hyperbook": "Import Hyperbook from a file",
    "shell-export-hyperbook": "Export Hyperbook to a file",
    "breadcrumb-navigation": "Breadcrumb",
    "breadcrumb-home": "Home",
    "qr-code": "QR Code",
    "p5-update": "Update",
    "p5-code-preview": "Code Preview",
    "p5-reset": "Reset",
    "p5-copy": "Copy",
    "p5-download": "Download",
    "abc-music-reset": "Reset",
    "abc-music-copy": "Copy",
    "abc-music-download": "Download",
    "table-of-contents": "Table of Contents",
    "audio-play": "Play/Pause",
    "archive-offline": "Offline",
    "download-offline": "Offline",
    "ide-fullscreen-enter": "Fullscreen",
    "ide-fullscreen-exit": "Exit Fullscreen",
    "pyide-run": "Run",
    "pyide-running": "Running ...",
    "pyide-running-click-to-stop": "Running (Click to stop) ...",
    "pyide-running-refresh-to-stop": "Running (Refresh to stop) ...",
    "pyide-test": "Test",
    "pyide-testing": "Test running ...",
    "pyide-test-running-click-to-stop": "Test running (Click to stop) ...",
    "pyide-test-running-refresh-to-stop": "Test running (Refresh to stop) ...",
    "pyide-stop": "Stop",
    "pyide-stop-refresh": "Stop (refresh)",
    "pyide-locked-other-instance-running": "Another PyIDE instance is running",
    "pyide-stopping": "Stopping ...",
    "pyide-stop-reloading": "Stopping requires a refresh on this page. Reloading now...",
    "pyide-stop-refresh-required": "Stop requested. If execution does not stop, refresh the page or enable COOP/COEP headers.",
    "pyide-output": "Output",
    "pyide-canvas": "Canvas",
    "pyide-input": "Input",
    "pyide-input-prompt": "Input required:",
    "pyide-reset": "Reset",
    "pyide-copy": "Copy",
    "pyide-download": "Download",
    "slideshow-previous": "Previous",
    "slideshow-next": "Next",
    "slideshow-jump-to": "Jump to {{index}}",
    "toggle-bookmark": "Toggle Bookmark",
    "shell-share": "Share",
    "share-dialog-title": "Create Shareable URL",
    "share-dialog-standalone": "Standalone Mode",
    "share-dialog-select-sections": "Select Sections",
    "share-dialog-copy-url": "Copy Shareable URL",
    "share-dialog-url-copied": "URL copied to clipboard!",
    "webide-code-preview": "Code Preview",
    "webide-html": "HTML",
    "webide-css": "CSS",
    "webide-js": "JS",
    "webide-reset": "Reset",
    "webide-reset-prompt": "Are you sure you want to reset the code?",
    "webide-copy": "Copy",
    "webide-download": "Download", 
    "typst-code": "Typst",
    "typst-reset": "Reset",
    "typst-reset-prompt": "Are you sure you want to reset the code?",
    "typst-download-pdf": "Download PDF",
    "typst-pdf-error": "Error exporting PDF",
    "typst-download-project": "Download Project",
    "typst-loading": "Loading Typst...",
    "typst-add-source-file": "Add source file",
    "typst-add-binary-file": "Add binary file",
    "typst-source": "Source",
    "typst-binary": "Binary",
    "typst-add": "Add",
    "typst-delete-file": "Delete file",
    "typst-delete-confirm": "Delete",
    "typst-filename-prompt": "Enter filename (e.g., helper.typ):",
    "typst-filename-error": "Filename must end with .typ or .typst",
    "typst-filename-exists": "File already exists",
    "typst-file-replace": "Replace existing file?",
    "typst-binary-files": "Binary Files",
    "typst-no-binary-files": "No binary files",
    "openscad-preview": "Preview",
    "openscad-render": "Render",
    "openscad-copy": "Copy",
    "openscad-copy-done": "Code copied",
    "openscad-download": "Download",
    "openscad-download-format": "Download format",
    "openscad-download-stl": "Download STL",
    "openscad-download-ready": "Download ready",
    "openscad-reset": "Reset",
    "openscad-reset-prompt": "Are you sure you want to reset the code?",
    "openscad-rendering": "Rendering ...",
    "openscad-render-success": "Render complete",
    "openscad-render-failed": "OpenSCAD render failed",
    "openscad-params-object": "Parameters must be a JSON object",
    "openscad-params-loading": "Loading parameters...",
    "openscad-params-none": "No parameters",
    "openscad-parameters": "Parameters",
    "openscad-binary-files": "Binary Files",
    "openscad-no-binary-files": "No binary files",
    "openscad-add-binary-file": "Add binary file",
    "openscad-add": "Add",
    "openscad-file-replace": "Replace existing file?",
    "user-login-title": "Login",
    "user-username": "Username",
    "user-password": "Password",
    "user-login": "Login",
    "user-info-title": "User Info",
    "user-status": "Status",
    "user-saved": "Saved",
    "user-saving": "Saving...",
    "user-save-error": "Save Error",
    "user-unsaved": "Unsaved changes",
    "user-offline": "Offline",
    "user-offline-queued": "Saved locally",
    "user-save": "Save Now",
    "user-logout": "Logout",
    "user-login-required": "Username and password required",
    "user-login-failed": "Login failed",
    "user-logout-confirm": "Are you sure you want to logout?",
    "user-readonly": "Read-Only Mode",
    "user-impersonating": "Impersonating",
    "user-exit-impersonation": "Exit Impersonation",
    "consent-youtube-text": "Clicking the play button will load a YouTube video via YouTube-NoCookie. However, a connection will still be established and the necessary data will be transmitted.",
    "consent-youtube-nocookie": "We use YouTube-NoCookie to protect your privacy.",
    "consent-youtube-always": "Always allow YouTube videos",
    "consent-youtube-accept": "Accept and play",
    "consent-embed-text": "Content from an external website is to be loaded here.",
    "consent-embed-personal-data": "The external website may collect personal data.",
    "consent-embed-always": "Always allow content from {{domain}}",
    "consent-embed-accept": "Load content"
}
